<template>

    <div class="page p-visit_list">
        <the-dashboard-heading :back-href="{ name: 'PatientShow', params: { id: patient.id }}">
            <h2>
                <router-link :to="{ name: 'Patients' }">Pacjenci</router-link>
                <router-link :to="{ name: 'PatientShow', params: { id: patient.id }}">{{ patientName }}</router-link>
                <span>{{ issue.name }}</span>
            </h2>
        </the-dashboard-heading>

        <the-dashboard-content>
            <visit-list class="p-visit_list__list"></visit-list>
        </the-dashboard-content>

        <v-pagination v-model="visits.last_page"></v-pagination>
    </div>

</template>


<script>

import {mapGetters} from 'vuex'
import store from 'Store'

import TheDashboardHeading from 'Components/Dashboard/TheDashboardHeading'
import TheDashboardContent from 'Components/Dashboard/TheDashboardContent'
import VPagination from 'Components/VPagination'

import VisitList from 'Components/Visit/VisitList'

export default {

    name: 'ViewPatientVisits',

    data() {
        return {
            isFetching: false
        }
    },

    computed: {
        ...mapGetters('visits', ['visits', 'issue', 'patient']),
        patientName() {
            return this.patient.first_name + ' ' + this.patient.last_name
        },
    },

    beforeRouteEnter(to, from, next) {
        store.dispatch('PAGE_LOADING_SET')
        Promise.all([
            store.dispatch('visits/FETCH_VISITS', {
                issueId: to.query.issue_id,
                page: to.query.page
            }),
            store.dispatch('visits/FETCH_PATIENT', to.params.id),
            store.dispatch('visits/FETCH_ISSUE', to.query.issue_id),

        ]).then(() => {
            store.dispatch('PAGE_LOADING_RESET')
            next()
        })
    },

    components: {
        TheDashboardHeading,
        TheDashboardContent,
        VPagination,
        VisitList
    }

}

</script>


<style lang="scss">

.p-visit_list {
    &__list {
        width: 100%;
    }
}

</style>
